import React from "react";
import { Bar } from "react-chartjs-2";
import { euroFormatter } from "src/global";
import ChartCard from "../ChartCard";
import { withPaymentDistributionStyles } from "../chartStyles";

const PaymentDistributionChart = ({ paymentDistributionChart }) => {
  return (
    <ChartCard chart={paymentDistributionChart}>
      <Bar
        data={withPaymentDistributionStyles(paymentDistributionChart.data)}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function (value) {
                  const num = Number(value);
                  return euroFormatter(num);
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
      />
    </ChartCard>
  );
};

export default PaymentDistributionChart;
